import React from 'react';

/**
 * 加载动画（Vant V01 圆形 spinner，waphn.189.cn 同款）
 * - SVG circle + stroke-dasharray 动画，颜色继承 currentColor
 * - size 控制直径，缺省 16px（与旧 btn-loading 一致）
 *
 * @param {object}   props
 * @param {number}   [props.size=16]    - spinner 直径（px）
 * @param {object}   [props.style]      - 附加内联样式
 * @param {string}   [props.className]  - 附加类名
 * @returns {JSX.Element}
 */
function LoadingSpinner({ size = 16, style, className }) {
  return (
    <span
      className={'gt-loading' + (className ? ' ' + className : '')}
      style={{ width: size, height: size, ...style }}
      role="status"
      aria-label="加载中"
    >
      <svg viewBox="25 25 50 50" className="gt-loading__circular">
        <circle cx="50" cy="50" r="20" fill="none"></circle>
      </svg>
    </span>
  );
}

export default LoadingSpinner;
